import { useTranslation } from 'react-i18next';
export function useErrorMessage(error, context = {}) {
  const {
    t,
    i18n
  } = useTranslation();
  if (!error) {
    return '';
  }
  let errorMessage = String(typeof error === 'object' && 'message' in error ? error.message : error);

  /**
   * To allow for translated error messages, schema error messages
   * are allowed to be an i18n key.
   * Example can be found at:
   * https://github.com/BrandSourceDigital/hub/blob/1cce5382a93015a7e06685302e5901a4b1aa36d8/libs/data/dtos/src/util-structs.ts#L43
   */
  if (errorMessage && i18n.exists(errorMessage)) {
    errorMessage = t(errorMessage, context);
  }

  // Return undefined instead of an empty string to make it more explicit that
  // there is no error message.
  return errorMessage || undefined;
}